import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

// Mirrors api/core/workers.go::UpdateWorkerPayrollDetailsRequest.
// externalPayrollSystemId is the link itself (blank = not in the payroll
// system). Set-once: capturable pre-link to mark an already-migrated
// worker as linked (or to recover a failed-push timeout), immutable after
// that — the whole endpoint is refused once the worker is linked.
export default class UpdateWorkerPayrollDetailsRequest extends BaseUpdateRequest {
    payrollNumber = '';
    nationalInsuranceNumber = '';
    // Sent on the worker CREATE (provider derives tax defaults from it) —
    // capturable before first sync only.
    ukStarterDeclaration = 0;
    externalPayrollSystemId = '';
}
